module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17 17",
      url: "img/" + "sprite.svg#edit-usage",
      toString: function () {
        return this.url;
      }
    }